import useTheme from "@mui/material/styles/useTheme";
export const useCheckThemeContext = (component) => {
    const theme = useTheme();
    if (!theme.pixel) {
        throw new Error(`Pixel components require a ThemeProvider with a Pixel theme. The component ${component} is used outside of the ThemeProvider scope.`);
    }
    return theme;
};
